import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to the top on page changes, or to the matching section when the URL has a #hash.
export function ScrollToTop() {
  const {
    pathname,
    hash,
    key
  } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const id = decodeURIComponent(hash.slice(1));
    let attempts = 0;
    let timer: number | undefined;
    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else if (attempts < 20) {
        attempts += 1;
        timer = window.setTimeout(scrollToTarget, 50);
      }
    };
    scrollToTarget();
    return () => window.clearTimeout(timer);
  }, [pathname, hash, key]);
  return null;
}